import React from 'react';
import Button from 'components/common/Button';
import getActiveUsersQuery from 'ApolloClient/Queries/getActiveUsers';
import ApolloClient from 'ApolloClient/index.js';
import Papa from 'papaparse';
import moment from 'moment';

const downloadFile = (data, exportFilename) => {
  let csvData = new Blob([data], { type: 'text/csv;charset=utf-8;' });
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(csvData, exportFilename);
  } else {
    // In FF link must be added to DOM to be clicked
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(csvData);
    link.setAttribute('download', exportFilename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

class DownloadUsersButton extends React.PureComponent {
  state = {
    loading: false,
  };

  shapeData = data =>
    data.map(user => {
      console.log(user);
      return {
        userId: user._id,
        email: user.emails[0].address,
        last: user.profile.lastName,
        first: user.profile.firstName,
        numberOfClients: user.organization && user.organization.numberOfClients,
        numberOfContracts: user.organization && user.organization.numberOfContracts,
        numberOfInvoices: user.organization && user.organization.numberOfInvoices,
        lastInvoice:
          user.organization &&
          user.organization.lastInvoice &&
          moment(user.organization.lastInvoice).format('MM/DD/YYYY'),
        lastContract:
          user.organization &&
          user.organization.lastContract &&
          moment(user.organization.lastContract).format('MM/DD/YYYY'),
      };
    });

  generateCSV = data => {
    let cleanData = this.shapeData(data);
    console.log(cleanData);
    let dataSource = Papa.unparse(cleanData, { header: true });
    downloadFile(dataSource, 'user-data.csv');
    this.setState({ loading: false });
  };

  onClick = async () => {
    let res = await ApolloClient.query({ query: getActiveUsersQuery });
    console.log(res);
    this.generateCSV(res.data.getActiveUsers);
    //    .then(res => this.generateCSV(res.data.userDataDownload));
  };

  render() {
    return (
      <div>
        <Button onClick={this.onClick}>Download Active Users</Button>
      </div>
    );
  }
}

export default DownloadUsersButton;



// WEBPACK FOOTER //
// ./src/routes/admin-users/DownloadActiveUsers/index.js